<template>
  <div class="registration">
    <Row class="header" type="flex" align="middle" v-if="aleadly">
      <Tabs>
        <TabPane :label="$t('global.text21')" />
        <TabPane
          :label="$t('global.text22')"
          v-if="data.attachments && data.attachments.length"
        />
      </Tabs>
    </Row>
    <div class="registration_form" v-if="aleadly">
      <div class="left">
        <Timeline>
          <TimelineItem v-for="(v, i) in data.groups" :key="i">
            {{ v.groupName }}
          </TimelineItem>
        </Timeline>
      </div>
      <div class="center">
        <Form
          :model="workInfo"
          label-position="top"
          class="text-left"
          ref="workInfo"
        >
          <div
            style="
              padding-bottom: 15px;
              margin-bottom: 15px;
              border-bottom: 1px solid #e8eaec;
            "
          >
            <p class="groupName text-left">
              {{ $t('global.text28') }}
              <Tag color="orange">{{ $t('global.text24') }}</Tag>
            </p>
          </div>
          <FormItem
            prop="displayName"
            :rules="[
              {
                required: true,
                message: $t('global.text13')
              }
            ]"
            :label="$t('global.text27')"
            class="test456456"
          >
            <Input
              style="width: 300px"
              maxlength="100"
              show-word-limit
              :placeholder="$t('global.text13')"
              v-model="workInfo.displayName"
            />
          </FormItem>
        </Form>
        <div v-for="(v, i) in data.groups" :key="i">
          <div
            class="group-box"
            style="
              padding-bottom: 15px;
              margin-bottom: 15px;
              border-bottom: 1px solid #e8eaec;
            "
          >
            <p class="groupName text-left">
              {{ v.groupName }}
              <Tag color="orange" v-if="v.requiredFlag">
                {{ $t('global.text24') }}
              </Tag>
            </p>
            <p
              class="gary-text text-left"
              :class="{ statement: v.group === 'declarationAndSignature' }"
            >
              {{ v.description }}
            </p>
            <div
              class="add-new-item"
              v-if="v.group === 'education' || v.group === 'experience'"
              @click="addNewItem(v)"
            >
              <a class="ver-middle font-14">
                <Icon type="ios-add-circle-outline" size="20"></Icon>
                {{ $t('global.add') }}
              </a>
            </div>
          </div>

          <div
            class="content-box"
            v-if="
              v.group !== 'education' &&
              v.group !== 'experience' &&
              v.group !== 'emergencyContact'
            "
          >
            <Form
              :model="created_form[v.group]"
              :ref="v.group"
              :rules="rules[v.group]"
            >
              <template v-for="(val, k) in v.items">
                <div
                  :key="k"
                  class="content-item"
                  v-if="val.fieldName !== 'mobilePrefix'"
                >
                  <FormItem
                    :label="val.name"
                    :prop="val.fieldName"
                    v-if="val.fieldName !== 'expectedSalaryRange'"
                  >
                    <!-- text -->
                    <Input
                      style="width: 100%"
                      :placeholder="setDescription(val)"
                      v-model="created_form[v.group][val.fieldName]"
                      v-if="
                        val.type === 'TEXT' &&
                        val.props.type !== 'NUMBER' &&
                        val.fieldName !== 'handwrittenSignatureImage'
                      "
                    >
                      <Select
                        v-if="
                          $_.indexOf(['phone', 'mobile'], val.fieldName) !== -1
                        "
                        v-model="created_form[v.group].mobilePrefix"
                        slot="prepend"
                        style="width: 100px"
                      >
                        <Option
                          v-for="(a, i) in areaCodeList"
                          :key="i"
                          :value="`${a.value}`"
                          :label="`+${a.value}`"
                        >
                          {{ a.key }}+{{ a.value }}
                        </Option>
                      </Select>
                    </Input>

                    <!-- number -->
                    <InputNumber
                      style="width: 100%"
                      :min="0"
                      v-model="created_form[v.group][val.fieldName]"
                      :placeholder="setDescription(val)"
                      v-if="val.type === 'TEXT' && val.props.type === 'NUMBER'"
                    ></InputNumber>

                    <!-- select -->
                    <Select
                      style="width: 100%; text-align: left"
                      v-model="created_form[v.group][val.fieldName]"
                      :multiple="val.props.selectMultiple"
                      v-if="
                        val.type === 'SELECT' && val.fieldName !== 'countryId'
                      "
                      :placeholder="setDescription(val)"
                    >
                      <template
                        v-if="
                          $_.indexOf(
                            ['mobilePrefix', 'countryId'],
                            val.fieldName
                          ) === -1
                        "
                      >
                        <Option
                          v-for="op in val.props.value"
                          :value="op.value"
                          :key="op.value"
                        >
                          {{ getLocaleValue(op.label) }}
                        </Option>
                      </template>
                    </Select>

                    <CountryCascader
                      ref="countryCascader"
                      v-model="countryIds"
                      :placeholder="setDescription(val)"
                      style="width: 100%; text-align: left"
                      @on-change="
                        onCountryCascaderChange($event, v.group, val.fieldName)
                      "
                      v-if="val.fieldName === 'countryId'"
                    />

                    <!-- date -->
                    <DatePicker
                      v-model="created_form[v.group][val.fieldName]"
                      v-if="val.type === 'DATE' && val.fieldName !== 'birth'"
                      type="date"
                      @on-change="created_form[v.group][val.fieldName] = $event"
                      style="width: 100%"
                      :placeholder="setDescription(val)"
                      :options="datePickerOptions"
                      @on-open-change="
                        onOpenDatePickerChange(
                          $event,
                          created_form[v.group],
                          val.fieldName
                        )
                      "
                    ></DatePicker>
                    <!-- 生日 -->
                    <DatePicker
                      v-model="created_form[v.group][val.fieldName]"
                      v-if="val.type === 'DATE' && val.fieldName === 'birth'"
                      type="date"
                      style="width: 100%"
                      :placeholder="setDescription(val)"
                      :options="datePickerOptions"
                      @on-open-change="
                        onOpenDatePickerChange(
                          $event,
                          created_form[v.group],
                          val.fieldName
                        )
                      "
                      @on-change="
                        onDatePickerChange(v.group, k, created_form[v.group])
                      "
                    ></DatePicker>
                    <!-- 手写签名 -->
                    <div v-if="val.fieldName === 'handwrittenSignatureImage'">
                      <Button @click="onSignOpen(v.groupName)">
                        {{ val.description }}
                      </Button>
                      <Row
                        class="sign-row"
                        type="flex"
                        align="middle"
                        :gutter="5"
                        v-if="signUrl"
                      >
                        <Col>
                          <div class="sign-image">
                            <img class="sign-img" :src="signUrl" alt="sign" />
                          </div>
                        </Col>
                        <Col>
                          <Icon
                            class="cur-p"
                            type="ios-trash-outline"
                            :size="25"
                            color="#ed4014"
                            @click="onSignDel"
                          />
                        </Col>
                      </Row>
                    </div>
                  </FormItem>
                </div>
              </template>
            </Form>
          </div>

          <!-- 工作经验和教育经验单独处理 -->
          <div
            class="content-box"
            v-if="
              v.group === 'education' ||
              v.group === 'experience' ||
              v.group === 'emergencyContact'
            "
          >
            <div
              v-for="(subItem, parentIndex) in created_form[v.group + 's']"
              :key="parentIndex + 'sdfsdfsdff'"
            >
              <Form :model="subItem" :ref="v.group + 's' + parentIndex">
                <template v-for="(val, subIndex) in v.items">
                  <div
                    :key="subIndex + 'dsfsdf21245'"
                    class="content-item"
                    v-if="val.fieldName !== 'mobilePrefix'"
                  >
                    <FormItem
                      :label="val.name"
                      :prop="val.fieldName"
                      :rules="
                        val.fieldName === 'phone'
                          ? checkPhone
                          : [
                              {
                                required:
                                  (v.group === 'experience' &&
                                    experienceRequired) ||
                                  v.group !== 'experience'
                                    ? val.requiredFlag
                                    : false,
                                message: setDescription(val)
                              }
                            ]
                      "
                    >
                      <!-- text -->
                      <Input
                        @on-change="
                          changeArrayForm(v.group + 's', parentIndex, subItem)
                        "
                        style="width: 100%"
                        :placeholder="setDescription(val)"
                        v-model="subItem[val.fieldName]"
                        v-if="
                          val.type === 'TEXT' && val.props.type !== 'NUMBER'
                        "
                      >
                        <Select
                          v-if="
                            $_.indexOf(['phone', 'mobile'], val.fieldName) !==
                            -1
                          "
                          v-model="subItem.mobilePrefix"
                          slot="prepend"
                          style="width: 100px"
                        >
                          <Option
                            v-for="(a, i) in areaCodeList"
                            :key="i"
                            :value="`${a.value}`"
                            :label="`+${a.value}`"
                          >
                            {{ a.key }}+{{ a.value }}
                          </Option>
                        </Select>
                      </Input>

                      <!-- number -->
                      <InputNumber
                        @on-change="
                          changeArrayForm(v.group + 's', parentIndex, subItem)
                        "
                        style="width: 100%"
                        :min="0"
                        v-model="subItem[val.fieldName]"
                        :placeholder="setDescription(val)"
                        v-if="
                          val.type === 'TEXT' && val.props.type === 'NUMBER'
                        "
                      ></InputNumber>

                      <!-- select -->
                      <Select
                        @on-change="
                          changeArrayForm(v.group + 's', parentIndex, subItem)
                        "
                        style="width: 100%; text-align: left"
                        :multiple="val.props.selectMultiple"
                        v-model="subItem[val.fieldName]"
                        v-if="val.type === 'SELECT'"
                        :placeholder="setDescription(val)"
                      >
                        <Option
                          v-for="op in val.props.value"
                          :value="op.value"
                          :key="op.value"
                        >
                          {{ getLocaleValue(op.label) }}
                        </Option>
                      </Select>

                      <!-- date -->
                      <DatePicker
                        v-model="subItem[val.fieldName]"
                        v-if="val.type === 'DATE'"
                        type="date"
                        @on-change="
                          changeArrayForm(v.group + 's', parentIndex, subItem)
                        "
                        style="width: 100%"
                        :placeholder="setDescription(val)"
                        :options="datePickerOptions"
                        @on-open-change="
                          onOpenDatePickerChange($event, subItem, val.fieldName)
                        "
                      ></DatePicker>
                    </FormItem>
                  </div>
                </template>
              </Form>
              <hr
                v-if="
                  created_form[v.group + 's'].length > 1 &&
                  parentIndex !== created_form[v.group + 's'].length - 1
                "
              />
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <template v-if="data.attachments && data.attachments.length">
          <Button
            type="primary"
            v-if="!$route.query.view"
            style="line-height: 32px"
            :loading="sb_loading"
            @click="on_form_valid"
          >
            {{ $t('global.text23') }}
          </Button>
          <Button
            type="primary"
            style="line-height: 32px"
            v-if="$route.query.view"
            :to="`/improveEmployeeFiles/form/${$route.params.teamId}`"
          >
            {{ $t('global.text18') }}
          </Button>
          <Button
            type="primary"
            :loading="sb_loading"
            style="margin-left: 10px; line-height: 32px"
            ghost
            @click="on_form_valid(true)"
          >
            {{ $t('global.text19') }}
          </Button>
        </template>
        <Button
          type="primary"
          :loading="sb_loading"
          style="margin-left: 10px; line-height: 32px"
          @click="on_form_valid(true)"
          v-else
        >
          {{ $t('global.text17') }}
        </Button>
      </div>
      <div class="mobile-footer">
        <!-- <Button
          type="primary"
          style="line-height: 32px"
          :loading="sb_loading"
          @click="on_form_valid(true)"
          long
          v-if="data.attachments && data.attachments.length"
        >
          {{ $t("global.text17") }}
        </Button> -->
        <template v-if="data.attachments && data.attachments.length">
          <Button
            type="primary"
            v-if="!$route.query.view"
            style="line-height: 32px"
            :loading="sb_loading"
            @click="on_form_valid"
          >
            {{ $t('global.text23') }}
          </Button>
          <Button
            type="primary"
            style="line-height: 32px"
            v-if="$route.query.view"
            :to="`/recruitment/welcome/${$route.params.teamId}/${$route.params.formId}?view=1`"
          >
            {{ $t('global.text18') }}
          </Button>
          <Button
            type="primary"
            :loading="sb_loading"
            style="line-height: 32px; margin-top: 10px"
            ghost
            @click="on_form_valid(true)"
          >
            {{ $t('global.text19') }}
          </Button>
        </template>
        <Button
          type="primary"
          style="line-height: 32px"
          :loading="sb_loading"
          @click="on_form_valid(true)"
          long
          v-else
        >
          {{ $t('global.text17') }}
        </Button>
      </div>
    </div>

    <Spin size="large" v-if="!aleadly" class="loading-span"></Spin>
    <handwritten-signature ref="handwrittenSignature" @on-ok="onSignOk" />
  </div>
</template>
<script>
import axios from 'axios';
import { mapState, mapMutations } from 'vuex';
import app_config from '@/commons/app_config';
import HandwrittenSignature from '@/components/handwritten-signature.vue';
import CountryCascader from '@/components/country-cascader.vue';
import scrollTo from '@/assets/js/scrollTo.js';
import { getLocaleValue } from '@/assets/js/multilingual-tools';
import localeToAreaCode from '@/assets/js/locale-to-area-code';
export default {
  data() {
    return {
      created_form: {},
      objectNames: {
        contactInfo: 'contact_info',
        personalInfo: 'personal_info',
        salaryInfo: 'salary_info',
        education: 'education',
        experience: 'experience',
        emergencyContact: 'emergency_contact',
        otherInfo: 'other_info'
      },
      workInfo: {
        displayName: null
      },
      sb_loading: false,
      areaCodeList: [],
      success: [],
      valid_edit: [],
      datePickerOptions: null,
      params: {},
      formId: '', // 表单id
      aleadly: false,
      registrationTemplateId: '', // 模板id
      experienceRequired: true,
      checkPhone: [], // 紧急联系人电话号码验证
      //   data: {}
      signUrl: null,
      countryIds: [],
      mobilePrefix: null
    };
  },
  components: {
    HandwrittenSignature,
    CountryCascader
  },
  computed: {
    ...mapState({
      data: (state) => _.cloneDeep(state.r_form),
      form: (state) => _.cloneDeep(state.form)
    }),
    rules() {
      const rules = {};
      _.forEach(this.data.groups, (e) => {
        rules[e.group] = {};
        _.forEach(e.items, (item) => {
          if (item.fieldName !== 'mobilePrefix') {
            if (
              _.indexOf(
                ['phone', 'mobile', 'email', 'workEmail'],
                item.fieldName
              ) === -1
            ) {
              rules[e.group][item.fieldName] = [
                {
                  required: item.requiredFlag,
                  message: this.setDescription(item)
                }
              ];
            }
            if (_.indexOf(['phone', 'mobile'], item.fieldName) !== -1) {
              const validatemobile = async (rule, value, callback) => {
                if (!value) {
                  return callback(
                    new Error(this.$t('global.enter_true_mobile_phone'))
                  );
                }
                if (this.created_form[e.group].mobilePrefix === '852') {
                  if (value.length !== 8) {
                    return callback(
                      new Error(this.$t('global.enter_true_mobile_phone'))
                    );
                  }
                } else {
                  if (
                    !this.$parsePhoneNumberFromString(
                      value,
                      `+${this.created_form[e.group].mobilePrefix}`
                    )
                  ) {
                    return callback(
                      new Error(this.$t('global.enter_true_mobile_phone'))
                    );
                  }
                }
                const mPattern = /[^\d]/g;
                if (mPattern.test(value)) {
                  return callback(
                    new Error(this.$t('global.enter_true_mobile_phone'))
                  );
                }
              };
              rules[e.group][item.fieldName] = [
                {
                  required: item.requiredFlag,
                  validator: validatemobile
                }
              ];
            }
            if (_.indexOf(['email', 'workEmail'], item.fieldName) !== -1) {
              rules[e.group][item.fieldName] = [
                {
                  type: 'email',
                  required: item.requiredFlag,
                  message: this.$t('global.enter_true_work_email'),
                  trigger: 'blur'
                }
              ];
            }
            if (item.fieldName === 'birth') {
              const validatebirth = async (rule, value, callback) => {
                if (!value) {
                  return callback(new Error(this.setDescription(item)));
                } else {
                  callback();
                }
              };
              rules[e.group][item.fieldName] = [
                {
                  required: item.requiredFlag,
                  validator: validatebirth
                }
              ];
            }
          }
        });
      });
      return rules;
    }
  },
  watch: {
    'created_form.careerObjective.currentWorkingStatus': {
      handler: function (newVal, oldVal) {
        // 目前工作状态为应届毕业生时工作经验为非必填
        if (newVal === 'graduates') {
          this.experienceRequired = false;
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        } else {
          this.experienceRequired = true;
          this.$forceUpdate();
        }
      },
      deep: true
    }
  },

  mounted() {
    if (this.$route.query) {
      const e = this.$route.query;
      e.token = JSON.parse(e.token);
      this.$i18n.locale = e.i18n;
      this.get_app_params(e);
    }
    // 本地测试
    // this.init();
  },
  methods: {
    ...mapMutations({
      set_form: 'set_form',
      set_form1: 'set_form1'
    }),
    // 获取多语言对应值
    getLocaleValue(data) {
      return getLocaleValue(data);
    },
    // 获取手机区号列表
    async getMobilePrefixList() {
      const res = await this.$http(
        'get',
        'public/dictionaries/area_code',
        { code: 'area_code' },
        true
      );
      this.areaCodeList = res.data.dictValues;
      try {
        const item = _.find(this.areaCodeList, (v) => {
          const extendedValue = v.extendedValue && JSON.parse(v.extendedValue);
          return (
            extendedValue &&
            extendedValue.countryCode === localeToAreaCode[this.$i18n.locale]
          );
        });
        const defaultValue =
          process.env.VUE_APP_REGION === 'yoov' ? '852' : '86';
        this.mobilePrefix = item ? `${item.value}` : defaultValue;
      } catch (e) {
        console.log(e);
      }
    },
    // 手写签名
    onSignOpen(name) {
      this.$refs.handwrittenSignature.open(name);
    },
    // 保存签名
    async onSignOk(e) {
      try {
        this.signUrl = e;
        const form = new FormData();
        form.append('image', this.dataURLtoBlob(e));
        const res = await axios({
          method: 'post',
          url: `${app_config.mainApiEndpoint}/rest/api/v1/mobile/employee/document/handwritten_signature/image/${this.params.teamId}/${this.formId}`,
          data: form,
          headers: {
            'X-TENANT-ID': this.params.teamId,
            Authorization: `bearer ${this.params.token.access_token}`
          }
        });
        this.created_form.declarationAndSignature.handwrittenSignatureImage =
          res.data.name;
        this.$refs.declarationAndSignature[0].validateField(
          'handwrittenSignatureImage'
        );
      } catch (e) {
        this.$Message.error(this.$t('global.signSaveError'));
      }
    },
    // 删除签名
    async onSignDel() {
      try {
        await axios({
          method: 'delete',
          url: `${app_config.mainApiEndpoint}/rest/api/v1/mobile/employee/document/handwritten_signature/image/${this.params.teamId}/${this.formId}?name=${this.created_form.declarationAndSignature.handwrittenSignatureImage}`,
          headers: {
            'X-TENANT-ID': this.params.teamId,
            Authorization: `bearer ${this.params.token.access_token}`
          }
        });
        this.signUrl = null;
        this.created_form.declarationAndSignature.handwrittenSignatureImage =
          null;
      } catch (e) {
        this.$Message.error(this.$t('global.signDelError'));
      }
    },
    dataURLtoBlob(dataURI) {
      const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]; // mime类型
      const byteString = atob(dataURI.split(',')[1]); //base64 解码
      const arrayBuffer = new ArrayBuffer(byteString.length); //创建缓冲数组
      const intArray = new Uint8Array(arrayBuffer); //创建视图

      for (let i = 0; i < byteString.length; i++) {
        intArray[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([intArray], {
        type: mimeString
      });
      return new File([blob], `${new Date().getTime()}.png`);
    },
    // 设置description
    setDescription(v) {
      if (v.description) {
        return v.description;
      } else {
        if (v.type === 'DATE' || v.type === 'SELECT') {
          return this.$t('i.select.placeholder');
        } else {
          return this.$t('i.textPlaceholder');
        }
      }
    },
    get_app_params(e) {
      this.setLang(e.i18n);
      this.params = e;
      localStorage.setItem('params', JSON.stringify(this.params));
      this.init();
    },

    async init() {
      await this.getTemplateData();
      await this.getMobilePrefixList();
      // 本地测试
      // await this.getTemplateDataTwo();

      this.setApiData();
      // 根据是否有个人信息判断是新建还是编辑
      if (this.form.personalInfo) {
        this.setEditFormData(this.form);
      }

      this.setCheckPhoneRule();

      if (this.form && this.form.displayName) {
        this.workInfo.displayName = this.form.displayName;
      }
      // this.set_form(this.data);

      // this._init_form()
      await this.getFormId();
      // 本地测试
      // await this.getFormIdTwo();
    },

    // 设置工资信息
    setSalaryInfo(data) {
      let list = [];
      for (let i of this.data.groups) {
        if (i.group === 'salaryInfo') {
          list = i.items;
        }
      }
      let obj = {};
      for (let i of data.attributes) {
        for (let j of list) {
          if (i.attribute.fieldName === j.fieldName) {
            obj[j.fieldName] = i.value;
          }
        }
      }
      this.created_form.salaryInfo = obj;
    },
    // 设置個人信息
    setPersonalInfo(data) {
      let list = [];
      for (let i of this.data.groups) {
        if (i.group === 'personalInfo') {
          list = i.items;
        }
      }
      let obj = {};
      for (let i of data.attributes) {
        for (let j of list) {
          if (i.attribute.fieldName === j.fieldName) {
            obj[j.fieldName] = i.value;
          }
        }
      }
      this.created_form.personalInfo = Object.assign(
        {},
        this.created_form.personalInfo,
        obj
      );
      // 设置国家级联选择器回显
      if (this.created_form.personalInfo.countryInfo) {
        this.countryIds =
          this.created_form.personalInfo.countryInfo.countryTreeId;
      }
    },
    // 国家选择
    onCountryCascaderChange(value, groupName, fieldName) {
      this.created_form[groupName][fieldName] = _.last(value);
    },
    // 设置聯係信息
    setContactInfo(data) {
      let list = [];
      for (let i of this.data.groups) {
        if (i.group === 'contactInfo') {
          list = i.items;
        }
      }
      let obj = {};
      for (let i of data.attributes) {
        for (let j of list) {
          if (i.attribute.fieldName === j.fieldName) {
            obj[j.fieldName] = i.value;
          }
        }
      }
      this.created_form.contactInfo = Object.assign(
        {},
        this.created_form.contactInfo,
        obj
      );
    },
    // 设置紧急联系人电话号码校验
    setCheckPhoneRule() {
      let arr = [];
      for (let i of this.data.groups) {
        if (i.group === 'emergencyContact') {
          for (let j of i.items) {
            if (j.fieldName === 'phone') {
              let reuqired = {
                required: j.requiredFlag,
                message: j.description
              };
              arr.push(reuqired);
            }
          }
        }
      }
      // 如果有紧急联系人手机号码，则要校验手机号码是否正确
      if (arr.length < 1) return;
      let vm = this;
      let validateFun = {
        async validator(rule, value, callback, source, options) {
          if (!value) {
            return callback(new Error(vm.$t('global.enter_true_mobile_phone')));
          }

          if (vm.created_form.emergencyContacts[0].mobilePrefix === '852') {
            if (value.length !== 8) {
              return callback(
                new Error(vm.$t('global.enter_true_mobile_phone'))
              );
            }
          } else {
            if (
              !vm.$parsePhoneNumberFromString(
                value,
                `+${vm.created_form.emergencyContacts[0].mobilePrefix}`
              )
            ) {
              return callback(
                new Error(vm.$t('global.enter_true_mobile_phone'))
              );
            }
          }

          const mPattern = /[^\d]/g;
          if (mPattern.test(value)) {
            return callback(new Error(vm.$t('global.enter_true_mobile_phone')));
          }
        }
      };
      arr.push(validateFun);
      this.checkPhone = arr;
    },

    // 手动更改工作经验，教育经历，紧急联系人数组动态校验值
    changeArrayForm(groupName, index, item) {
      let _tempObj = _.cloneDeep(item);
      this.created_form[groupName][index] = '';
      this.$set(this.created_form[groupName], index, _tempObj);
    },

    setEditFormData(data) {
      // 其他信息要单独处理
      if (data.otherInfo) {
        this.dealOtherInfo(data.otherInfo);
      }
      if (data.salaryInfo) {
        this.setSalaryInfo(data.salaryInfo);
      }
      if (data.personalInfo) {
        this.setPersonalInfo(data.personalInfo);
      }
      if (data.contactInfo) {
        this.setContactInfo(data.contactInfo);
      }
    },

    // 设置其他信息
    dealOtherInfo(data) {
      let obj = {};
      if (data.attributes) {
        for (let i of data.attributes) {
          obj[i.attribute.fieldName] = i.value;
        }
        this.created_form.otherInfo = obj;
      }
    },

    // 设置后台接口绑定数据格式
    setApiData() {
      this.data.groups.forEach((v) => {
        if (
          v.group === 'education' ||
          v.group === 'experience' ||
          v.group === 'emergencyContact'
        ) {
          let name = v.group + 's';
          if (
            this.form[name] &&
            this.form[name].length > 0 &&
            !this.isPreview
          ) {
            this.$set(this.created_form, name, this.form[name]);
          } else {
            this.$set(this.created_form, name, []);
            let obj = {};
            let val = v.items;
            for (let i = 0; i < val.length; i++) {
              let newValue = '';
              // 设置手机号前缀
              if (val[i].fieldName === 'mobilePrefix') {
                const mobilePrefix = val[i].props.value[0];
                if (mobilePrefix) {
                  // 手机号前缀-区号
                  newValue = mobilePrefix;
                } else {
                  newValue = this.this.mobilePrefix;
                }
              } else {
                newValue = val[i].h_value ? val[i].h_value : null;
              }
              obj[val[i].fieldName] = this.isPreview ? '' : newValue;
            }
            this.created_form[name][0] = obj;
          }
        } else {
          if (this.form[v.group] && !this.isPreview) {
            this.$set(this.created_form, v.group, this.form[v.group]);
          } else {
            this.$set(this.created_form, v.group, {});
            v.items.forEach((val, index) => {
              let value = '';
              if (!this.isPreview) {
                value = val.h_value ? val.h_value : null;
              }
              // 设置手机号前缀
              if (val.fieldName === 'mobilePrefix') {
                const mobilePrefix = val.props.value[0];
                if (mobilePrefix) {
                  // 手机号前缀-区号
                  value = mobilePrefix;
                } else {
                  value = this.this.mobilePrefix;
                }
              }
              if (val.fieldName === 'expectedSalaryRange') {
                let rangeVal = {
                  left: 0,
                  right: 0
                };
                value = rangeVal;
              }
              this.$set(this.created_form[v.group], val.fieldName, value);
            });
          }
        }
      });
    },

    // 新增项目，校验和工作经验
    addNewItem(group) {
      let index = this.created_form[group.group + 's'].length - 1;
      let newIndex = index + 1;
      let obj = this.created_form[group.group + 's'][0];
      let newObj = {};
      for (let i in obj) {
        newObj[i] = null;
      }
      this.$set(this.created_form[group.group + 's'], newIndex, newObj);
    },

    // 设置语言
    setLang(key) {
      localStorage.setItem('i18n', key);
      this.$i18n.locale = key;
      document.body.className =
        this.$i18n.locale === 'en' ? 'en-font' : 'hk-font';
      window.localStorage.setItem('switchLanguage', true);
      // 设置国家语言列表多语言
      this.$refs.countryCascader &&
        this.$refs.countryCascader[0] &&
        this.$refs.countryCascader[0].getData();
    },

    // 本地测试
    async getTemplateDataTwo() {
      try {
        let res = await this.$http(
          'GET',
          `${app_config.mainApiEndpoint}/rest/api/v1/mobile/employee/document/template`,
          {},
          true
        );
        console.log('模板数据--', res.data);
        this.registrationTemplateId = res.data.id;
        this.set_form(res.data);
        setTimeout(() => {
          this.aleadly = true;
        }, 2000);
      } catch (e) {
        setTimeout(() => {
          this.aleadly = true;
        }, 2000);
        if (e.data.code === 500) {
          this.$router.push({ path: '/fileExisted' });
        }
        // this.$Message.error(e.data.message);
      }
    },

    // 获取模板数据
    async getTemplateData() {
      let lang = localStorage.getItem('i18n');
      if (lang === 'cn') {
        lang = 'zh-CN';
      }
      if (lang === 'hk') {
        lang = 'zh-HK';
      }
      const res = await axios({
        method: 'GET',
        url: `${app_config.mainApiEndpoint}/rest/api/v1/mobile/employee/document/template`,
        headers: {
          'X-TENANT-ID': this.params.teamId,
          Authorization: `bearer ${this.params.token.access_token}`,
          'Accept-Language': lang
        }
      }).catch((e) => {
        this.$Message.error(e.response.data.code);

        console.log(
          '%c 🌮 e.response: ',
          'font-size:20px;background-color: #7F2B82;color:#fff;',
          e.response
        );
        if (e.response.data.code === 500) {
          this.$router.push({ path: '/fileExisted' });
        } else {
          this.$Message.error(e.response.data.message);
        }
        this.aleadly = true;
      });
      this.aleadly = true;
      // console.log("this.data---", this.data);
      // const res = await this.$http(
      //   "get",
      //   "mobile/employee/document/template",
      //   {},
      //   true
      // );
      // this.data = res.data;
      this.registrationTemplateId = res.data.id;
      this.set_form(res.data);
    },

    // 本地测试
    async getFormIdTwo() {
      //   this.formId = res.data.id;
      this.$http('get', 'mobile/employee/document/form', {}, true).then(
        (res) => {
          this.formId = res.data.id;
        }
      );
    },

    // 获取表单id
    async getFormId() {
      let lang = localStorage.getItem('i18n');
      if (lang === 'cn') {
        lang = 'zh-CN';
      }
      if (lang === 'hk') {
        lang = 'zh-HK';
      }
      const res = await axios({
        method: 'GET',
        url: `${app_config.mainApiEndpoint}/rest/api/v1/mobile/employee/document/form`,
        headers: {
          'X-TENANT-ID': this.params.teamId,
          Authorization: `bearer ${this.params.token.access_token}`,
          'Accept-Language': lang
        }
      }).catch((e) => {
        this.$Message.error(e.response.data.message);
      });
      this.formId = res.data.id;
      if (res.data.declarationAndSignature) {
        this.created_form.declarationAndSignature.handwrittenSignatureImage =
          res.data.declarationAndSignature.handwrittenSignatureImage;
        this.signUrl =
          res.data.declarationAndSignature.handwrittenSignatureImageUrl;
      }
      // this.$http('get', 'mobile/employee/document/form', {}, true).then(res => {
      //   this.formId = res.data.id;
      // })
    },

    async _init_form() {
      try {
        // let res = await this.$http('GET', `${app_config.mainApiEndpoint}/rest/api/v1/mobile/employee/document/form`, {data: this.formValidate}, true)
        const res = await axios({
          method: 'GET',
          url: `${app_config.mainApiEndpoint}/rest/api/v1/mobile/employee/document/form`,
          headers: {
            'X-TENANT-ID': this.params.teamId,
            Authorization: `bearer ${this.params.token.access_token}`
          },
          data: this.formValidate
        }).catch((e) => {
          this.$Message.error(e.response.data.message);
        });

        this.sb_loading = false;

        _.forEach(this.data.groups, (val) => {
          if (res.data[val.group]) {
            _.forEach(val.items, (val1) => {
              this.$set(
                val1,
                'h_value',
                res.data[val.group][val1.fieldName]
                  ? res.data[val.group][val1.fieldName]
                  : null
              );
            });
          }
        });
        this.set_form(this.data);
      } catch (e) {}
    },
    // 年龄判断
    onDatePickerChange(groupName, index, item) {
      if (this.$i18n.locale === 'hk') {
        // 香港地區僱傭兒童警告
        const curDate = this.$moment();
        const birth = this.$moment(item.birth);
        const difference = curDate.diff(birth, 'years');
        if (difference < 13) {
          item.birth = null;
          this.$set(this.created_form[groupName], index, item);
          this.$Modal.warning({
            title: this.$t('global.warning'),
            content: this.$t('global.childrenWarningText')
          });
        } else if (difference > 12 && difference < 18) {
          this.$Modal.warning({
            title: this.$t('global.warning'),
            content: this.$t('global.underAgeWarningText')
          });
        }
      }
    },
    onOpenDatePickerChange(status, item, name) {
      if (!status) return;
      let datePickerOptions = null;
      // 生日
      if (name === 'birth') {
        let birth = null;
        datePickerOptions = {
          disabledDate(date) {
            const workDates = [
              item.firstWorkDate,
              item.workingVisaStartDate,
              item.workingVisaEndDate
            ];
            for (const value of workDates) {
              if (value) {
                let workDate = new Date(value);
                workDate = workDate.valueOf() - 86400000;
                birth = date && date.valueOf() > workDate;
              }
            }
            if (birth) {
              // 已选择首次工作时间或工作签证开始时间或工作签证结束时间
              return birth;
            } else {
              return date && date.valueOf() > Date.now();
            }
          }
        };
      }
      // 工作签证开始时间并且已选择首次工作时间
      if (name === 'workingVisaStartDate' && item.firstWorkDate) {
        datePickerOptions = {
          disabledDate(date) {
            let workDate = new Date(item.firstWorkDate);
            workDate = workDate.valueOf() - 86400000;
            return date && date.valueOf() < workDate;
          }
        };
      }
      // 工作签证结束时间并且已选择首次工作时间
      if (name === 'workingVisaEndDate' && item.firstWorkDate) {
        datePickerOptions = {
          disabledDate(date) {
            let workDate = new Date(item.firstWorkDate);
            workDate = workDate.valueOf();
            return date && date.valueOf() < workDate;
          }
        };
      }
      if (name === 'firstWorkDate') {
        datePickerOptions = {
          disabledDate(date) {
            return date && date.valueOf() > Date.now();
          }
        };
      }
      // 首次工作时间并且已选择工作签证开始时间或工作签证结束时间
      if (
        (name === 'firstWorkDate' && item.workingVisaStartDate) ||
        (name === 'firstWorkDate' && item.workingVisaEndDate)
      ) {
        datePickerOptions = {
          disabledDate(date) {
            const workingDate = item.workingVisaStartDate
              ? item.workingVisaStartDate
              : item.workingVisaEndDate;
            let workDate = new Date(workingDate);
            workDate = workDate.valueOf() - 86400000;
            return date && date.valueOf() > workDate;
          }
        };
      }
      // 首次工作时间并且已选择工作签证开始时间和工作签证结束时间
      if (
        name === 'firstWorkDate' &&
        item.workingVisaStartDate &&
        item.workingVisaEndDate
      ) {
        datePickerOptions = {
          disabledDate(date) {
            let workDate = new Date(item.workingVisaStartDate);
            workDate = workDate.valueOf() - 86400000;
            return date && date.valueOf() > workDate;
          }
        };
      }
      // 工作签证开始时间不能晚于工作签证结束时间
      if (name === 'workingVisaEndDate' && item.workingVisaStartDate) {
        datePickerOptions = {
          disabledDate(date) {
            let workDate = new Date(item.workingVisaStartDate);
            workDate = workDate.valueOf();
            return date && date.valueOf() < workDate;
          }
        };
      }
      // 工作签证开始时间并且已选择工作签证结束时间
      if (name === 'workingVisaStartDate' && item.workingVisaEndDate) {
        datePickerOptions = {
          disabledDate(date) {
            let workDate = new Date(item.workingVisaEndDate);
            workDate = workDate.valueOf() - 86400000;
            return date && date.valueOf() > workDate;
          }
        };
      }
      // 首次工作时间、工作签证开始时间、工作签证结束时间，并且已选择生日
      /* if (item.birth) {
        const workingNames = [
          "firstWorkDate",
          "workingVisaStartDate",
          "workingVisaEndDate"
        ];
        if (_.includes(workingNames, name)) {
          datePickerOptions = {
            disabledDate(date) {
              let workDate = new Date(item.birth);
              workDate = workDate.valueOf();
              return date && date.valueOf() < workDate;
            }
          };
        }
      } */
      // 教育、工作经验开始时间并且已选择教育、工作结束时间
      if (name === 'startedDate' && item.endedDate) {
        datePickerOptions = {
          disabledDate(date) {
            let workDate = new Date(item.endedDate);
            workDate = workDate.valueOf() - 86400000;
            return date && date.valueOf() > workDate;
          }
        };
      }
      // 教育、工作经验开始时间不能晚于结束日期
      if (name === 'endedDate' && item.startedDate) {
        datePickerOptions = {
          disabledDate(date) {
            let workDate = new Date(item.startedDate);
            workDate = workDate.valueOf();
            return date && date.valueOf() < workDate;
          }
        };
      }
      this.datePickerOptions = datePickerOptions;
    },
    async on_form_valid(is_next) {
      // //預覽
      if (this.$route.query.view) {
        if (this.data.attachments.length > 0) {
          this.$router.push({
            path: `/improveEmployeeFiles/attachment/${this.params.teamId}/${this.formId}`
          });
        } else {
          this.$router.push({ path: '/improveEmployeeFiles/success' });
        }
      } else {
        this.valid_edit = [];
        this.$refs['workInfo'].validate(async (w_v) => {
          if (w_v) {
            await _.forEach(this.data.groups, (v) => {
              if (
                v.group === 'education' ||
                v.group === 'experience' ||
                v.group === 'emergencyContact'
              ) {
                let arr = this.created_form[v.group + 's'];
                for (let i = 0; i < arr.length; i++) {
                  this.$refs[v.group + 's' + i][0].validate(async (valid) => {
                    if (!valid && this.valid_edit.indexOf(v.groupName) === -1) {
                      this.valid_edit.push(v.groupName);
                    }
                  });
                }
              } else {
                this.$refs[v.group][0].validate(async (valid) => {
                  if (!valid) {
                    this.valid_edit.push(v.groupName);
                  }
                });
              }
            });
            await this.valid_post(is_next);
          } else {
            this.valid_edit.push(this.$t('global.text28'));
            this.errorScroll();
          }
        });
      }
    },
    async valid_post(is_next) {
      if (this.valid_edit.length === 0) {
        const info = {
          otherInfo: [],
          salaryInfo: [],
          contactInfo: [],
          personalInfo: []
        };
        _.forEach(this.data.groups, (v) => {
          if (
            _.indexOf(
              ['otherInfo', 'salaryInfo', 'contactInfo', 'personalInfo'],
              v.group
            ) !== -1
          ) {
            _.forEach(v.items, (val) => {
              if (val.fieldType === 1) {
                info[v.group].push({
                  attribute: val,
                  value:
                    val.type === 'SELECT' && val.props.selectMultiple
                      ? _.toString(this.created_form[v.group][val.templateCode])
                      : this.created_form[v.group][val.templateCode]
                });
              }
            });
          }
        });
        this.created_form.contactInfo.attributes = info.contactInfo;
        this.created_form.personalInfo.attributes = info.personalInfo;
        let formValidate = {
          declarationAndSignature: this.created_form.declarationAndSignature,
          displayName: this.workInfo.displayName,
          contactInfo: this.created_form.contactInfo,
          personalInfo: this.created_form.personalInfo,
          otherInfo: { attributes: info.otherInfo },
          salaryInfo: { attributes: info.salaryInfo },
          emergencyContacts: this.created_form.emergencyContacts
            ? this.created_form.emergencyContacts
            : [],
          educations: this.created_form.educations
            ? this.created_form.educations
            : [],
          experiences: this.created_form.experiences
            ? this.created_form.experiences
            : []
        };
        this.on_submits(formValidate, is_next);
        // 本地测试
        // this.on_submitsTwo(formValidate, is_next);
      } else {
        this.$Message.error(
          `${this.valid_edit.join(',')}${this.$t('apply.not_empty')}`
        );
        this.errorScroll();
      }
    },

    next(is_next) {
      this.form.displayName = this.workInfo.displayName;
      this.form.contactInfo = this.created_form.contactInfo;
      this.form.otherInfo = this.created_form.otherInfo;
      this.form.personalInfo = this.created_form.personalInfo;
      this.form.declarationAndSignature =
        this.created_form.declarationAndSignature;
      if (this.data.attachments && this.data.attachments.length > 0) {
        this.form.attachments = [];
      }
      if (this.created_form.emergencyContacts) {
        this.form.emergencyContacts = this.created_form.emergencyContacts;
      }
      if (this.created_form.educations) {
        this.form.educations = this.created_form.educations;
      }
      if (this.created_form.experiences) {
        this.form.experiences = this.created_form.experiences;
      }
      _.forEach(this.data.groups, (val) => {
        if (this.form[val.group]) {
          _.forEach(val.items, (val1) => {
            this.$set(
              val1,
              'h_value',
              this.created_form[val.group][val1.fieldName]
                ? this.created_form[val.group][val1.fieldName]
                : null
            );
          });
        }
      });
      this.set_form(this.data);
      this.set_form1(this.form);
      if (is_next) {
        if (this.data.attachments.length > 0) {
          this.$router.push({
            path: `/improveEmployeeFiles/attachment/${this.$route.params.teamId}/${this.formId}`
          });
        } else {
          this.$router.push({ path: '/improveEmployeeFiles/success' });
        }
      }
    },

    // 本地测试
    async on_submitsTwo(formValidate, is_next) {
      try {
        this.sb_loading = true;
        const res = await this.$http(
          'POST',
          `/mobile/employee/document/form?registrationTemplateId=${this.registrationTemplateId}`,
          { ...formValidate, id: this.formId },
          true
        );
        console.log('结果', res);
        this.sb_loading = false;
        this.next(is_next);
      } catch (e) {
        this.$Message.error({
          content: e.response.data.message,
          duration: 8
        });
        this.sb_loading = false;
      }
    },

    async on_submits(formValidate, is_next) {
      try {
        this.sb_loading = true;
        // 时间各种转换
        this.convertTimeFormat(formValidate);
        const res = await axios({
          method: 'POST',
          url: `${app_config.mainApiEndpoint}/rest/api/v1/mobile/employee/document/form?registrationTemplateId=${this.registrationTemplateId}`,
          headers: {
            'X-TENANT-ID': this.params.teamId,
            Authorization: `bearer ${this.params.token.access_token}`
          },
          data: { ...formValidate, id: this.formId }
        }).catch((e) => {
          this.$Message.error(e.response.data.message);
          this.sb_loading = false;
        });

        // let res = await this.$http(
        //   "POST",
        //   `mobile/employee/document/form?registrationTemplateId=${this.data.id}`,
        //   { ...formValidate, id: this.formId },
        //   true
        // );
        console.log('结果', res);
        this.sb_loading = false;
        this.next(is_next);
      } catch (e) {
        this.$Message.error({
          content: e.response.data.message,
          duration: 8
        });
        this.sb_loading = false;
      }
    },

    // 执行转换时间格式操作
    convertTimeFormat(data) {
      if (data.personalInfo.birth) {
        data.personalInfo.birth = this.$moment(data.personalInfo.birth).format(
          'YYYY-MM-DD'
        );
      }
      if (data.personalInfo.workingVisaEndDate) {
        data.personalInfo.workingVisaEndDate = this.$moment(
          data.personalInfo.workingVisaEndDate
        ).format('YYYY-MM-DD');
      }
      if (data.personalInfo.workingVisaStartDate) {
        data.personalInfo.workingVisaStartDate = this.$moment(
          data.personalInfo.workingVisaStartDate
        ).format('YYYY-MM-DD');
      }
      if (data.personalInfo.firstWorkDate) {
        data.personalInfo.firstWorkDate = this.$moment(
          data.personalInfo.firstWorkDate
        ).format('YYYY-MM-DD');
      }
      if (data.personalInfo.passportExpiredDate) {
        data.personalInfo.passportExpiredDate = this.$moment(
          data.personalInfo.passportExpiredDate
        ).format('YYYY-MM-DD');
      }
    },
    // 定位到表单错误位置
    errorScroll() {
      scrollTo('.ivu-form-item-error', '.registration');
    }
  }
};
</script>
<style lang="less" scoped>
.header {
  justify-content: center;
  height: 50px;
}

hr {
  border: none;
  height: 1px;
  background-color: #ccc;
  margin-bottom: 10px;
}

.group-box {
  position: relative;
}

.add-new-item {
  display: inline-block;
  position: absolute;
  top: 10px;
  right: 10px;
}

.loading-span {
  display: inline-block;
  margin: 100px auto;
}

.test456456.ivu-form-item {
  margin-bottom: 30px;
}
.test456456.ivu-form-item:after {
  clear: none;
}

.error-message {
  margin: 100px auto;
  > * {
    font-size: 26px;
    color: #39be6b;
  }
}

.registration {
  overflow-y: scroll;
  height: 100vh;
}
.registration_form {
  width: 1200px;
  padding-bottom: 50px;
  box-sizing: content-box;
  margin: 50px auto 0 auto;
  .left {
    left: 30%;
    float: left;
  }
  .center {
    width: 70%;
    margin-left: 30%;
  }
  .footer,
  .mobile-footer {
    width: 100%;
    margin-top: 20px;
  }
  .mobile-footer {
    display: none;
  }
}

/deep/.ivu-tabs-bar {
  border-bottom: none;
}

/deep/.ivu-tabs-tab {
  pointer-events: none;
}

/deep/.warn-modal {
  .ivu-modal-header {
    border-bottom: none !important;

    .ivu-icon {
      font-size: 28px;
      color: #f90;
    }

    .title {
      vertical-align: middle;
      margin-left: 12px;
      font-size: 16px;
      color: #17233d;
      font-weight: 500;
    }
  }

  .ivu-modal-body {
    padding: 0 58px;
  }

  .ivu-modal-footer {
    border-top: none !important;
  }
}

.content-box {
  width: 100%;
  text-align: left;
  .content-item {
    width: 50%;
    display: inline-block;
    padding: 0 7px;
    vertical-align: top;
  }
}
@media only screen and (max-width: 768px) {
  .registration_form {
    width: 92%;
    padding: 15px 15px 100px 15px;
    margin-top: 10px;
    .left {
      display: none;
    }
    .center {
      margin: 0;
      width: 100%;
    }
    .mobile-footer {
      display: block;
      button {
        width: 95%;
      }
    }
    .footer {
      display: none;
    }
  }

  .content-box .content-item {
    width: 100%;
  }
}

/deep/.input-text .ivu-input {
  padding-right: 58px;
}

.statement {
  white-space: pre-line;
}

.sign-row {
  margin: 10px 0 0 0 !important;
}

.sign-image {
  width: 200px;
  background-color: #fff;

  .sign-img {
    width: 100%;
  }
}
</style>
